export class EditorMessages {

  public editorMessagesHash;
  public messages;

  constructor() {
    this.messages = [];
    this.editorMessagesHash = {};
  }

  addEditorMessage(key, message, translateParams?) {
    if (this.editorMessagesHash[key] !== message) {
      this.editorMessagesHash[key] = { message, translateParams };
      this.refreshEditorMessage();
    }
  }

  removeEditorMessage(key) {
    if (this.editorMessagesHash[key] !== null) {
      this.editorMessagesHash[key] = null;
      this.refreshEditorMessage();
    }
  }

  refreshEditorMessage() {
    this.messages = [];
    const keys = Object.keys(this.editorMessagesHash);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const editorMessage = this.editorMessagesHash[key];
      if (editorMessage && editorMessage.message) {
        this.messages.push(editorMessage);
      }
    }
  }

  clearAllMessages() {
    const keys = Object.keys(this.editorMessagesHash);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      this.editorMessagesHash[key] = null;
    }

    this.refreshEditorMessage();
  }
}
